module.exports = __webpack_public_path__ + "static/media/medal_level8.bc345a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/levels/medal_level8.png
// module id = 305
// module chunks = 0